import { APIPaths } from "@/apis/api-config";

import BaseApi from "../base-api";

export class ImageApi extends BaseApi {
  async postImageNew(
    requestBody: APIPaths["/operator-dash/image/new"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/operator-dash/image/new"]["post"]["responses"]["201"]["content"]["application/json"]> {
    return (await this.post("/operator-dash/image/new", requestBody)).data;
  }
}
